/**滚动banner**/
<template>
  <div class="rollBanner">
    <ul class="imgList">
      <li v-for="(itme,index) in data" :class="index==imgAcNum?'liAc':''" @click="imgListAcFn(itme)">
        <div class="img"><img :src="itme.imgUrl"></div>
      </li>
    </ul>
    <ul class="Buttons">
      <li v-for="(itme,index) in data"><span class="but" :class="index==imgAcNum?'butAc':''"
                                             @click="butFn(index)"></span>
      </li>
    </ul>
  </div>
</template>

<script>
  import Toucth from '../../../../assets/js/method.js'
  import { mapGetters } from 'vuex'
  export default {
    name: 'xk-rollBanner',
    props: ['data', 'touch'],
    computed: {
      ...mapGetters({
        infoData: 'infoData'
      })
    },
    data () {
      return {
        imgAcNum: 0
      }
    },
    watch: {
      infoData: function () {
        this.animationFn()
      }
    },
    methods: {
      butFn: function (index) {
        this.imgAcNum = index
      },
      animationFn: function () {
        let that = this
        if (that.$props.data && that.$props.data.length > 0) {
          (function () {
            let state = true
            let setIn

            function setInFn () { // 自动循环
              clearInterval(setIn)
              setIn = setInterval(function () {
                that.imgAcNum++
                if (that.imgAcNum >= that.$props.data.length) {
                  that.imgAcNum = 0
                }
              }, 3000)
            }

            setInFn()
            if (state) {
              Toucth.slide(that.$el, function (val) {
                // console.log(val)
                clearInterval(setIn)
                switch (val) {
                  case 'right':
                    that.imgAcNum--
                    if (that.imgAcNum < 0) {
                      that.imgAcNum = that.$props.data.length - 1
                    }
                    break
                  case 'left':
                    that.imgAcNum++
                    if (that.imgAcNum > that.$props.data.length - 1) {
                      that.imgAcNum = 0
                    }
                    break
                }
                setTimeout(function () {
                  setInFn()
                }, 3000)
              })
            }
          })()
        }
      },
      imgListAcFn: function (obj) {
        if (obj.htmlUrl) {
          window.location.href = obj.htmlUrl
          return
        }
        if (obj.htmlContent) {
          window.bannerContent = obj.htmlContent
          this.$router.push('/bannerContent')
        }
      }
    },
    mounted: function () {
      this.animationFn()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .rollBanner {
    width: 100%;
    height: 100%;
    border-radius: 0.333rem;
    overflow: hidden;
    position: relative;
    background-color: #fff;
    .imgList {
      width: 100%;
      height: 100%;
      position: relative;
      li {
        width: 100%;
        height: 100%;
        position: absolute;
        transition: 0.8s all;
        z-index: 0;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        opacity: 0;
        .img {
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: 0.3s all;
          a {
            display: inline-block;
            width: 100%;
            height: 100%;
          }
          img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            height: 100%;
          }
        }
      }
      .liAc {
        z-index: 20;
        opacity: 1;
        .img {
          opacity: 1;
        }
      }
    }
    .Buttons {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 0);
      z-index: 50;
      li {
        width: 1.8rem;
        height: 1rem;
        position: relative;
        float: left;
        .but {
          box-sizing: border-box;
          position: absolute;
          left: 50%;
          top: 50%;
          width: 0.5rem;
          height: 0.5rem;
          margin: 0 0.666rem;
          border: 1px solid #f06553;
          opacity: 0.8;
          border-radius: 0.333rem;
          transition: 0.6s all;
          transform-origin: 50% 50%;
          transform: scale(1, 1) translate(-50%, -50%);
        }
        .butAc {
          background-color: #f06553;
          border-color: #f06553;
          transform: scale(1.2, 1.2) translate(-50%, -50%);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// rollBanner.vue?0b64dd82